import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import { Prompt, useHistory } from 'react-router-dom'

import UserActivityLog from '@SonarCX/components/molecules/UserActivityLog'
import ChannelSection from '../../../molecules/ChatModals/AddCustomerModal/ChannelSection'
import CustomerDetailsSection from '../../../molecules/ChatModals/AddCustomerModal/CustomerDetailsSection'
import TagsSection from '../../../molecules/ChatModals/AddCustomerModal/TagsSection'
import TasksSection from '../../../molecules/ChatModals/AddCustomerModal/TasksSection'
import UserFiles from '../../UserFiles'
import UserDetails from '../UserDetails'

import { useAreYouSure } from '../../../../providers/AreYouSureProvider'
import { useBreakpoint } from '../../../../providers/BreakpointProvider'
import { useCustomerContext } from '../../../../providers/CustomerProvider'
import { useEditContext } from '../../../../providers/EditProvider'
import useStyles from './styles'

const ProfileTable = ({
  details,
  filter,
  tab,
  update,
  updateUser,
  img,
  setDetails,
  canEdit,
  ...props
}) => {
  const history = useHistory()
  const { editedMeta, editedAuth, setEditedMeta, setEditedAuth } =
    useEditContext()
  const { setAction, setReason, setV2 } = useAreYouSure()
  const { down770 } = useBreakpoint()
  const { onFiles } = useCustomerContext()

  const [navigate, setNavigate] = React.useState(null)

  const classes = useStyles({ smallMedia: down770 })

  // Navigates away from this page after user denies saving
  React.useEffect(() => {
    if (editedMeta || editedAuth || !navigate) {
      return
    }

    history.push(navigate)
  }, [navigate, history, editedMeta, editedAuth])

  // Intercepts navigation event and shows 'Are you sure?' modal
  const handleNavigation = location => {
    if (editedMeta || editedAuth) {
      setReason('You have unsaved changes')
      setAction(() => {
        setEditedMeta(false)
        setEditedAuth(false)
        setNavigate(location.pathname)
      })
      setV2(true)
      return false
    }

    return true
  }

  return (
    <div className={classes.root}>
      <AnimatePresence mode='wait'>
        <motion.div
          key={onFiles ? 'on-files' : 'profile'}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -10, opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <div className={classes.container}>
            {onFiles ? (
              <div className={classes.section}>
                <UserFiles id={details.id} />
              </div>
            ) : (
              <>
                <CustomerDetailsSection
                  user={details}
                  canEdit={canEdit}
                  className={classes.section}
                />

                <div className={classes.section}>
                  <TagsSection canEdit={canEdit} />
                </div>

                <div className={classes.section}>
                  <TasksSection userID={details.id} />
                </div>

                {down770 && (
                  <>
                    <div className={classes.section}>
                      <ChannelSection user={details} canEdit={canEdit} />
                    </div>

                    <div className={classes.section}>
                      <UserDetails
                        details={details}
                        update={update}
                        updateUser={updateUser}
                        setDetails={setDetails}
                        canEdit={canEdit}
                      />
                    </div>
                  </>
                )}

                <div className={classes.section}>
                  <UserActivityLog user={details} />
                </div>
              </>
            )}
          </div>
        </motion.div>
      </AnimatePresence>

      <Prompt message={handleNavigation} when={editedMeta || editedAuth} />
    </div>
  )
}

export default ProfileTable
